import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type SettingsTranslations = {
  [lang: string]: Translation;
};

export const settingsTranslations: SettingsTranslations = {
  en,
};
